import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@americanexpress/dls-react';
import { parseHtml } from '../../utils/util';
/**
 * button component return DLS button component
 * @param {*} param0
 */
const GroupedCheckboxes = ({
  fieldOptions,
  fieldValidation,
  formSubmissionPayload,
  setFormSubmissionPayload,
  fieldId,
  curPageValues,
  setCurPageValues,
  fieldLabel,
  cssProperties,
  setValidationErrors,
  validationErrors,
  errors,
  fieldRank,
  setFocus,
}) => {
  const [options, setOptions] = useState(fieldOptions);
  const [validationError, setValidationError] = useState('');
  const [atleastOneSelected, setAtleastOneSelected] = useState(false);

  useEffect(() => {
    if (formSubmissionPayload && formSubmissionPayload[fieldId]) {
      fieldOptions = fieldOptions.map((fieldOption) => (formSubmissionPayload[fieldId].split(',').includes(fieldOption.fieldValue)
        ? { ...fieldOption, optionChecked: true }
        : { ...fieldOption, optionChecked: false }));
      setOptions(fieldOptions);
    }
  }, [fieldId]);

  useEffect(() => {
    const isAnySelected = options.some((option) => option.optionChecked);
    setAtleastOneSelected(isAnySelected);
  }, [options]);

  useEffect(() => {
    if (atleastOneSelected) {
      setValidationError('');
    }
  }, [atleastOneSelected]);

  const handleCheck = (e, option) => {
    if (e.target.checked) {
      const selectionGroupId = option.groupId;
      option.optionChecked = true;
      setAtleastOneSelected(true);
      if (formSubmissionPayload[fieldId]) {
        formSubmissionPayload[fieldId] = `${formSubmissionPayload[fieldId]},${option.fieldValue}`;
      } else {
        formSubmissionPayload[fieldId] = option.fieldValue;
      }

      setFormSubmissionPayload({
        ...formSubmissionPayload,
        elemId: null,
      });
      setCurPageValues({
        ...curPageValues,
        [fieldId]: formSubmissionPayload[fieldId],
      });
      options.forEach((curOption) => {
        // curOption.required = false;
        if (curOption.optionChecked && curOption.groupId !== selectionGroupId) {
          curOption.optionChecked = false;
          // if this oprtion has child inputs --> clear them
          if (curOption.childInputProps) {
            curOption.childInputProps.fieldValue = '';
            curOption.childInputProps.disabled = true;
          }
        }
      });
      if (option.childInputProps) {
        // enable the child input box
        option.childInputProps.disabled = false;
      }
    } else {
      option.optionChecked = false;
      const checkboxValues = formSubmissionPayload[fieldId].split(',');
      const checkedValues = checkboxValues.filter((value) => value !== option.fieldValue);
      formSubmissionPayload[fieldId] = [...checkedValues].join(',');
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        elemId: null,
      });
      setCurPageValues({
        ...curPageValues,
        [fieldId]: formSubmissionPayload[fieldId],
      });
      if (checkedValues.length === 0) {
        setAtleastOneSelected(false);
      }
      if (option.childInputProps) {
        // erase the child input box and disable
        option.childInputProps.fieldValue = '';
        option.childInputProps.disabled = true;
      }
    }
    setOptions([...options]);
  };

  const handleChildInputChange = (e, childInput) => {
    childInput.fieldValue = e.target.value;
    setOptions([...options]);
  };

  const invalidHandler = (e) => {
    e.preventDefault();
    // use setFocus methods here
    if (errors && fieldRank) {
      // custom validation message --> new implementation
      // disable the default validation message
      e.preventDefault();
      if (fieldValidation.required) {
        setValidationError(errors.mandatoryField);
      }
      setValidationErrors({
        ...validationErrors,
        ...{ [fieldRank]: `${fieldId}` },
      });
      setFocus({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    }
  };

  const isRequired = !atleastOneSelected ? !!fieldValidation?.required : false;
  return (
    <div className={cssProperties?.style}>
      <fieldset>
        {fieldLabel && fieldLabel.label && (
          <label className={fieldLabel.cssProperties?.style} htmlFor={fieldId}>
            {parseHtml(fieldLabel.label)}
          </label>
        )}
        <div className="row pad-1-l">
          {options.map((option) => (
            <>
              {option.fieldLabel.groupLabel && (
                <label
                  htmlFor={option.fieldId}
                  className={option.fieldLabel.cssProperties.groupLabelStyle}
                >
                  {parseHtml(option.fieldLabel.groupLabel)}
                </label>
              )}
              <div className={`checkbox ${option.cssProperties.style}`}>
                <input
                  type="checkbox"
                  id={option.fieldId}
                  name={option.fieldId}
                  onChange={(e) => handleCheck(e, option)}
                  checked={option.optionChecked}
                  value={option.optionChecked ? 'YES' : 'NO'}
                  required={isRequired}
                  onInvalid={invalidHandler}
                />
                <label htmlFor={option.fieldId}>
                  {parseHtml(option.fieldLabel.label)}
                </label>
              </div>
              {
                  option.childInputProps && (
                    <div className={option.childInputProps.cssProperties.style}>
                      <div className={option.childInputProps.cssProperties.additionalStyle}>
                        <Input
                          id={option.childInputProps.fieldId}
                          type={option.childInputProps.type}
                          value={option.childInputProps.fieldValue}
                          onChange={(e) => handleChildInputChange(e, option.childInputProps)}
                          required={option.childInputProps.required}
                          disabled={option.childInputProps.disabled}
                        />
                      </div>
                    </div>
                  )
                }
            </>
          ))}
        </div>
        {validationError && (
          <div id="alert-error" className="alert dls-color-warning pad-1-l">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{validationError}</span>
          </div>
        )}
      </fieldset>
    </div>
  );
};
GroupedCheckboxes.propTypes = {
  fieldOptions: PropTypes.arrayOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  errors: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  curPageValues: PropTypes.objectOf(PropTypes.shape),
  setCurPageValues: PropTypes.func,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  setValidationErrors: PropTypes.func,
  validationErrors: PropTypes.objectOf(PropTypes.shape),
  setFocus: PropTypes.func,
  fieldRank: PropTypes.number,
};

export default GroupedCheckboxes;
